/* eslint-disable no-unused-vars */
import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import { useAuth, SiteAuthRoute, AdminRoute } from './pages/Auth'

import { adminPath, path } from './Paths'
//nav
import AppNavigationBar from './App.navbar'

//pages
import LoadingLottie from './components/LoadingLottie'
import LoginPage from './pages/Login/LoginPage'
import DataCollectionPage from './pages/DataCollection/DataCollectionPage'
import GeneralDashboardPage from './pages/Dashboard/GeneralDashboard'
import UserAccountPage from './pages/User/UserAccountPage'

import EventInfoPage from './pages/Event/EventInfoPage'

import AdminDashboard from './pages/Admin/Dashboard'
import UsersPage from './pages/Users/UsersPage'

function AppRoutes() {
  const { currentUser, loading } = useAuth()

  if (currentUser == null) {
    return loading ? <LoadingLottie /> : <LoginPage />
  }

  return (
    <>
      {<AppNavigationBar />}
      <Routes>
        <Route
          exact
          path={path.home}
          element={<GeneralDashboardPage />}
        ></Route>
        <Route path={path.collection}>
          <Route index element={<DataCollectionPage />} />
        </Route>

        <Route element={<SiteAuthRoute />}>
          <Route path={`${path.collection}/:siteId`}>
            <Route index element={<DataCollectionPage />} />
            <Route path=":eventId" element={<EventInfoPage />}></Route>
          </Route>
        </Route>

        <Route
          exact
          path={path.userAccount}
          element={<UserAccountPage />}
        ></Route>

        <Route element={<AdminRoute />}>
          <Route exact path={adminPath.index} element={<AdminDashboard />} />
          <Route exact path={adminPath.users} element={<UsersPage />}></Route>
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  )
}

export default AppRoutes
